import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

interface DrawerMenuItemProps {
  text: string;
  icon?: JSX.Element;
  onClick?: () => void;
}

export const DrawerMenuItem = ({ text, icon, onClick }: DrawerMenuItemProps) => {
  return (
    <Flex
      alignItems={'center'}
      marginY={'0.5rem'}
      padding={'0.5rem'}
      gap={'8px'}
      borderRadius="lg"
      color="#96999C"
      _hover={{ backgroundColor: 'var(--gray-90)', color: 'white' }}
      _focus={{ backgroundColor: 'var(--gray-90)', color: 'white' }}
    >
      {icon}
      <Text onClick={() => onClick()} fontSize="16px" fontWeight="400">
        {text}
      </Text>
    </Flex>
  );
};
